import axios from "axios";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INPATIENT_URL] || process.env.REACT_APP_INPATIENT_API_URL;
const userMetaData = localStorageItem.get(KEY_LOCALSTORAGE.USER_METADATA);

export const getInpatientCategory = (code: string) => {
    let url = API_PATH + `/category/${code}`;
    return axios.get(url);
}

export const updateTreatmentFields = (treatmentId: string, fields: Record<string, any>) => {
    let url = `${API_PATH}/treatment/${treatmentId}/update-fields`;
    return axios.put(url, fields);
};

export const cloneParaclinical = (data: any) => {
    let payload = {
        ...data,
        pid: userMetaData?.personId,
    };
    let url = `${API_PATH}/service-prescription/paraclinical/clone`;
    return axios.post(url, payload);
};

export const cloneMedicalItem = (data: any) => {
    let payload = {
        ...data,
        pid: userMetaData?.personId,
    };
    let url = `${API_PATH}/service-prescription/medical-item/clone`;
    return axios.post(url, payload);
};